import React from 'react';
import { getIcon } from '@flybits/design-system';
import './FlowFileUploadStatusBanner.scss';

const MAIN_CLASS = 'flow-file-upload-status-banner';

export type FlowFileUploadStatusBannerTone = 'warning' | 'info';
export type FlowFileUploadStatusBannerLayout = 'stacked' | 'inline';

export type FlowFileUploadStatusBannerProps = {
  tone: FlowFileUploadStatusBannerTone;
  title?: string;
  description: React.ReactNode;
  layout?: FlowFileUploadStatusBannerLayout;
};

/** Shared ready-state copy for History and the Context Data Files dropdown. */
export const READY_TO_PROCESS_BANNER = {
  title: 'Confirm your selection',
  description: 'You can pause processing at any time. Pausing keeps files in the queue; it does not remove them.',
} as const;

const FlowFileUploadStatusBanner: React.FC<FlowFileUploadStatusBannerProps> = ({
  tone,
  title,
  description,
  layout = 'stacked',
}) => (
  <div className={`${MAIN_CLASS} ${MAIN_CLASS}--${tone} ${MAIN_CLASS}--${layout}`} role="status">
    {getIcon('infoFilled', {})}
    <div>
      {title && <strong>{title}</strong>}
      {layout === 'inline' ? ' ' : null}
      {description}
    </div>
  </div>
);

export default FlowFileUploadStatusBanner;
